import { Box, Typography } from "@mui/material";
import { BOOKING_STATUS, NOTIFICATION_TYPE } from "constants/general";
import { ROUTES } from "constants/routes";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { markAsReadNotifications } from "slices/notificationReducer";
import { useAppDispatch } from "store/appHooks";

const NotificationItem = ({
  title,
  description,
  is_seen,
  notification_type,
  booking_id,
  id,
  created_at,
  onClose,
}: {
  title: string;
  description: string;
  is_seen: boolean;
  notification_type: number;
  booking_id: number;
  id: number;
  created_at: string;
  onClose: any;
}) => {
  const router = useNavigate();
  const dispatch = useAppDispatch();

  const handleNotificationNavigation = () => {
    if (!is_seen) {
      dispatch(markAsReadNotifications({ id }));
    }
    if (notification_type === NOTIFICATION_TYPE.NEW_BOOKING_REQUEST) {
      router(`${ROUTES.RENTALS}?booking=${booking_id}&type=pending`); // owner rentals
    }
    if (notification_type === NOTIFICATION_TYPE.BOOKING_ACCEPTED) {
      router(ROUTES.PERSONAL_RENTAL); // personal rental
    }
    if (notification_type === NOTIFICATION_TYPE.BOOKING_REJECTED) {
      router(ROUTES.PERSONAL_RENTAL); // personal rental
    }
    if (notification_type === NOTIFICATION_TYPE.BOOKING_DATE_SUGGESTED) {
      router(ROUTES.PERSONAL_RENTAL); // personal rental
    }
    if (notification_type === NOTIFICATION_TYPE.NEW_LISTING_UNDER_REVIEW) {
      router(ROUTES.MANAGE_LISTING); // personal rental
    }
    if (notification_type === NOTIFICATION_TYPE.NEW_LISTING_APPROVED) {
      router(ROUTES.MANAGE_LISTING); // personal rental
    }
    if (notification_type === NOTIFICATION_TYPE.NEW_LISTING_DECLINED) {
      router(ROUTES.MANAGE_LISTING); // personal rental
    }
    onClose();
  };
  return (
    <Box
      sx={{
        px: "25px",
        py: "20px",
        borderBottom: "1px solid #E2E2E2",
        cursor: "pointer",
        background: !is_seen ? "#EAF0FF" : "#FFF",
      }}
      onClick={handleNotificationNavigation}
    >
      <Typography
        sx={{
          color: "#323232",
          fontWeight: 600,
          fontSize: "15px",
          lineHeight: "18px",
          mb: "10px",
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          color: "#A2A2A2",
          fontWeight: 400,
          fontSize: "14px",
          lineHeight: "22px",
          mb: "15px",
        }}
      >
        {description}
      </Typography>
      <Typography
        sx={{
          color: "#A2A2A2",
          fontWeight: 400,
          fontSize: "13px",
          lineHeight: "15px",
        }}
      >
        {moment(created_at).fromNow()}
      </Typography>
    </Box>
  );
};

export default NotificationItem;
